import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { MdBlock } from 'react-icons/md';

const ClubDisabledPopup: React.FC = () => {
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("user");
    localStorage.removeItem("permission");
    localStorage.removeItem("location_restriction");
    window.location.href = "/signin";
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          padding: '40px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        <MdBlock style={{ fontSize: '80px', color: '#f44336', marginBottom: '20px' }} />
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'var(--font-semibold)',
            color: '#22356D',
            marginBottom: '16px',
          }}
        >
          Club Access Disabled
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'var(--font-regular)',
            color: '#889ab6',
            marginBottom: '32px',
          }}
        >
          Your club has been temporarily disabled. You cannot access the admin panel at this time.
          Please contact your administrator or support for more information.
        </Typography>
        <Button
          onClick={handleLogout}
          sx={{
            backgroundColor: '#22356D',
            color: 'white',
            padding: '12px 32px',
            borderRadius: '8px',
            fontFamily: 'var(--font-medium)',
            '&:hover': {
              backgroundColor: '#1a2a5e',
            },
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default ClubDisabledPopup;
